import React from 'react';
import {PhoneInputProps as Props} from './PhoneInput.type';
import {Input} from '@damascus-components/Input_new';

import cn from './PhoneInput.module.scss';

export const PhoneInput = React.forwardRef(function PhoneInput(
  {countrySelect, ...props}: Props,
  ref
) {
  return (
    <Input
      ref={ref}
      className={`${cn.phone} ${props.className}`}
      placeholder='Phone Number'
      startAdornment={countrySelect}
      {...props}
    />
  );
});
